import { ColorEnum } from '@/constants/color'
import { StyleSheet } from 'react-native'

const styles = StyleSheet.create({
    card: {
        borderWidth: 1,
        borderColor: ColorEnum.GRAY_300,
        borderRadius: 8,
        padding: 16,
    },
    cardCompact: {
        padding: 12,
    },
    details: {
        gap: 4,
    },
    header: {
        flexDirection: 'row',
        alignItems: 'flex-start',
        gap: 16,
    },
    headerCompact: {
        alignItems: 'center',
    },
    name: {
        flex: 1,
        minWidth: 0,
        color: ColorEnum.GRAY_900,
    },
    rightContent: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',
        gap: 16,
    },
    rightContentCompact: {
        flex: 2,
        minWidth: 0,
        gap: 8,
    },
    quantity: {
        color: ColorEnum.BRICK_600,
        textAlign: 'right',
        textTransform: 'lowercase',
    },
    price: {
        minWidth: 85,
        color: ColorEnum.GRAY_900,
        textAlign: 'right',
    },
    priceExtended: {
        width: 105,
    },
})

export default styles
